export default __webpack_public_path__ + "static/car-fd8c2fc9fd941e1f1fc86c5eabfd1d26.jpg";